import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { factTableGetRequest } from "../../../_redux/_actions";

import {
     MainLeftTitle,
     CreateButton,
} from "../../_uiComponents/WrapperComponents";
import CreateLookUpTableForm from "./forms/CreateFactTableForm";
import { FORM_TYPE_ADD, FORM_TYPE_EDIT } from "../../../_helpers/constants";

export default function EditFactTable() {
     const { id } = useParams();
     const actionDispatch = useDispatch();

     useEffect(() => {
          actionDispatch(factTableGetRequest({ id }));
     }, []);

     const { details } = useSelector((state) => {
          return {
               details: state.factTable.details,
          };
     });

     return (
          <>
               <MainLeftTitle title="Update Fact Table"></MainLeftTitle>
               <CreateLookUpTableForm
                    type={FORM_TYPE_EDIT}
                    initialValues={{
                         id: details.id,
                         name: details.name,
                         typeId: details.typeId,
                         active: details.active,
                         labels: details.labels,
                    }}
               />
          </>
     );
}
